import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  #chat-widget-container, .chat-widget-container {
    display: none !important;
  }
  `;

const StickyWrapper = styled.div`
  margin-top: 0;
  margin-bottom: 0;
  padding: 0px 0px;
  will-change: transform;
  box-sizing: border-box;

  @media (orientation: portrait) {
    z-index: 11;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  @media (orientation: landscape) {
    position: relative;
    height: 100%;
    flex: 0 0 64px;
    //z-index: 10;
    //position: fixed;
    //right: 0;
    //top: 0;
    //bottom: 0;
    //width: 50px;
    //height: 100vh;
    //border-right: 1px solid #1b202d;
  }

  ${({ $flexMain }) =>
    $flexMain &&
    `
    position: relative;
    @media (orientation: portrait) {
        position: relative;
        height: 60px;
        flex: 0 0 64px;
    }
    // @media (orientation: landscape) {
    //   position: relative;
    //   height: 100%;
    // }
  `};
`;

const ContentStyle = styled.div`
  bottom: 0;
  position: absolute;
  align-items: center;
  //  background-color: #27262b;

  @media (orientation: portrait) {
    width: 100%;
    height: 60px;
    padding: 3px;
    background-color: #131315;
  }
  @media (orientation: landscape) {
    width: 64px;
    height: 100%;
    position: relative;
    background-color: transparent;
  }
`;

const StyleInner = styled.div`
  position: absolute;

  @media (orientation: portrait) {
    width: 100%;
    /* height: 74px; */
    left: 0px;
    //top: 8px;
  }
  @media (orientation: landscape) {
    //width: auto;
    height: 100%;
    //left: 7px;
    //top: 0px;
  }
`;

const ContainerStyle = styled.div`
  width: 100%;
  justify-content: space-between;

  @media (orientation: portrait) {
    padding-left: 2px;
    padding-right: 2px;
    display: inline-flex;
  }
  @media (orientation: landscape) {
    display: flex;
    height: 100%;
    flex-direction: column;
    padding: 4px;

    gap: 4px;
  }
`;

export {
  GlobalStyles,
  StickyWrapper,
  ContentStyle,
  StyleInner,
  ContainerStyle,
};
